export const isProductTeCloud = (entitlementsOfProduct) =>
  entitlementsOfProduct &&
  entitlementsOfProduct.length &&
  entitlementsOfProduct.length > 0 &&
  entitlementsOfProduct[0].application === 'TECloud'
